import React, { useState } from 'react';
import { ReactComponent as IconBlock } from '../../assets/icons/block.svg';
import { ReactComponent as IconBlockLetItRing } from '../../assets/icons/block-let-it-ring.svg';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import { setContactBlock } from '../../api';
import { showError } from '../../utils';

/* QUESTO POTREBBE ESSERE UTILIZZATO SIA DALLA RUBRICA CHE DALLE CHIAMATE */
const BlockButton = ({ callId, contactId, initial, setRawList }) => {
    if (initial === null) initial = 'Nessuno';

    const type = callId ? 'call' : 'contact';
    const id = type === 'call' ? callId : contactId;

    const BLOCK_MAP = {
        'Nessuno': { class: 'none', Icon: IconBlock },
        'Lascia squillare': { class: 'let-it-ring', Icon: IconBlockLetItRing },
        'Riaggancia subito': { class: 'hang-up', Icon: IconBlock }
    }

    /*
    //TODO: prendere da API /custom/pwa/tipibloccochiamata: mah... quando mai cambieranno... e poi sarabbero comunque da impostare class e icon
	"data": {
		"Nessuno": "Nessuno",
		"Lascia squillare": "Lascia squillare",
		"Riaggancia subito": "Riaggancia subito"
	},
    */

    const [block, setBlockState] = useState(initial);
    const [loadingBlock, setLoadingBlock] = useState(false);
    const keys = Object.keys(BLOCK_MAP);

    const handleClick = async () => {
        setLoadingBlock(true);
        const currentIndex = keys.indexOf(block);
        const nextBlock = keys[(currentIndex + 1) % keys.length];
        try {
            const response = await setContactBlock(id, nextBlock, type);
            if (response.code === 200) {
                setBlockState(nextBlock);
                if(setRawList && typeof setRawList === 'function') {
                    setRawList(prev => {
                        let newList = [...prev];
                        const index = newList.findIndex(item => item.id === id);
                        if (index !== -1) {
                            newList[index] = { ...newList[index], blocco: nextBlock };
                        }
                        return newList;
                    });
                }
            } else {
                showError(response.error_messages);
            }
        } catch (err) {
            showError([err.message]);
        } finally {
            setLoadingBlock(false);
        }
    };

    const { class: blockClass, Icon } = BLOCK_MAP[block] || BLOCK_MAP[2];
    return (
        <button className={`block-btn ${blockClass}`} disabled={loadingBlock} onClick={handleClick}>
            {loadingBlock ? <IconLoading className="icon icon-loading"/> : <Icon className="icon" />}
        </button>
    );
}
export default BlockButton;